import store from '@/utils/store'
export const columns = (vm) => {
    return [
        {
            type: 'index',
            width: 60,
            label: '序号',
            align: 'center',
            headerAlign: 'center',
        },
        {
            label: '用户名',
            prop: 'userName',
            align: 'left',
            headerAlign: 'left',
            width: 130
        },
        {
            label: '账号',
            prop: 'account',
            align: 'left',
            headerAlign: 'left',
            width: 130,
            render: (h, params) => {

                return h('span', {}, !!params.row.account ? params.row.account : "--")
            }
        },
        {
            label: '操作平台',
            prop: 'belongToType',
            align: 'canter',
            headerAlign: 'canter',
            width: 120,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.accountTypeList
                for (var i in list) {
                    if (params.row.belongToType * 1 == list[i].val * 1) {
                        text = list[i].title
                        color = list[i].color
                    }
                }
                console.log()
                return h('span', { style: { color: color } }, text)
            }
        },
        {
            label:'客户端类型',
            prop:'clientType',
            align:'canter',
            headerAlign:'canter',
            width: 120,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.clientList
                for (var i in list) {
                    if (params.row.clientType * 1 == list[i].val * 1) {
                        text = list[i].title
                        color = list[i].color
                    }
                }
                return h('div', {
                    style: {
                        color:color,
                        textAlign:"left"
                    }
                }, text)
            }
        },
        {
            label: '事件描述',
            prop: 'describes',
            align: 'left',
            headerAlign: 'left',
            width: 150
        },
        {
            label: '事件详情',
            prop: 'message',
            align: 'left',
            tooltip: true,
            headerAlign: 'left',
        },

        {
            label: '发生时间',
            prop: 'publishDate',
            align: 'left',
            headerAlign: 'left',
            width: 160
        }
    ]
}